$(function () {
  $('[data-toggle="tooltip"]').tooltip()
});




//////////////////
// WEBPACK FOOTER
// ./static/js/web/custom.js
// module id = qv8e
// module chunks = 4